/* DZ Ansageleiste (Runde 61)

   Wechselt die Eintraege von selbst. Kein Wischen, keine Pfeile,
   kein Ziehen - und kein Swiper.

   Pausiert bei Hover und bei Fokus innerhalb der Leiste.
   prefers-reduced-motion: kein Wechsel; dann bleibt der erste Text
   stehen und die uebrigen bleiben fuer Screenreader lesbar. */

(function () {
  'use strict';

  function start(wurzel) {
    if (wurzel.dataset.dzBereit) return;
    wurzel.dataset.dzBereit = '1';

    var punkte = [].slice.call(wurzel.querySelectorAll('[data-dz-punkt]'));
    if (punkte.length < 2) return;

    var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (ruhig && ruhig.matches) {
      // Kein Wechsel. Damit trotzdem alle Ansagen vorgelesen werden,
      // kommt das aria-hidden von den uebrigen Eintraegen herunter -
      // sichtbar bleibt nur der erste, dafuer sorgt das CSS.
      wurzel.classList.add('dz-ansage--ruhig');
      wurzel.removeAttribute('aria-live');
      punkte.forEach(function (p) { p.removeAttribute('aria-hidden'); });
      return;
    }

    var takt = parseInt(wurzel.dataset.takt, 10) || 4000;
    var jetzt = 0;
    var uhr = null;
    var pausiert = false;

    function zeige(i) {
      punkte.forEach(function (p, n) {
        var an = n === i;
        p.classList.toggle('dz-ansage__punkt--an', an);
        if (an) p.removeAttribute('aria-hidden');
        else p.setAttribute('aria-hidden', 'true');
      });
    }

    function weiter() {
      if (pausiert || document.hidden) return;
      jetzt = (jetzt + 1) % punkte.length;
      zeige(jetzt);
    }

    function laufen() {
      if (uhr) return;
      uhr = setInterval(weiter, takt);
    }
    function halten() {
      if (!uhr) return;
      clearInterval(uhr);
      uhr = null;
    }

    wurzel.addEventListener('mouseenter', function () { pausiert = true; });
    wurzel.addEventListener('mouseleave', function () { pausiert = false; });
    wurzel.addEventListener('focusin', function () { pausiert = true; });
    wurzel.addEventListener('focusout', function () { pausiert = false; });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) halten();
      else laufen();
    });

    laufen();
  }

  function alleStarten() {
    document.querySelectorAll('[data-dz-ansage]').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alleStarten);
  } else {
    alleStarten();
  }
  document.addEventListener('shopify:section:load', alleStarten);
})();
